{
  "featuredSermon": "Featured Sermon",
  "discussionQuestions": "Discussion Questions",
  "details": "Details"
}
